import ConfigManager from '@/config/ConfigManager.js'
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { TniConfigModel } from '../model/TniConfigModel';

export default { 
    /**
     * Return TniConfigModel
     */
     apiGetTniConfig: function() {
        //https://cdn.buzzebees-uat.com/th/apps/1007101429346759/config.json
        let appId = ConfigManager.getAppId(); 
        let url = ConfigManager.getBlobUrl() + `/apps/${appId}/config.json`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map((res) => {
            return new TniConfigModel(res.data);   
        }));
    }, 
}
